import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhaseOne = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 273,
	height: 182,
	viewBox: "0 0 273 182",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "bg",
			d: "M48 98.6015C48 108.949 56.9265 133.661 76.2357 144.53C95.9518 155.628 112.482 146.342 135.733 146.708C153.294 146.985 164.116 151.894 180.708 146.708C204.185 139.372 229.656 126.793 224.272 104.955C220.527 89.7687 202.694 90.0152 191.599 78.088C180.531 66.1897 181.718 53.9058 168.002 44.5039C138.311 24.1521 102.101 39.4012 74.4206 61.9313C60.3555 73.3792 48 88.2539 48 98.6015Z",
			fill: "#031A6B",
			fillOpacity: .02
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 165.489,
			cy: 118.088,
			rx: 24.5195,
			ry: 23.7484,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.315 78.0744C169.64 96.4794 154.57 110.852 145.12 115.738V117.037C170.866 102.194 161.977 84.8773 154.315 78.0744Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M153.357 76.9612C149.909 75.2295 142.4 71.1354 139.948 68.6121C143.715 68.7358 151.671 70.5788 153.357 76.9612Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.614 83.6404C154.57 84.0115 149.411 83.6775 145.12 79.3731C147.638 78.5691 153.463 78.297 156.614 83.6404Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.296 94.4014C157.252 93.7211 152.974 91.136 152.208 86.2379C155.081 86.2998 160.521 88.019 159.296 94.4014Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.614 104.049C155.017 103.245 152.016 100.19 152.783 94.4014C155.528 95.0817 160.138 97.9637 156.614 104.049Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.185 112.769C147.483 110.852 146.691 106.201 149.143 102.936C151.505 104.111 154.621 107.723 148.185 112.769Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.208 113.883C153.676 112.027 158.299 108.02 165.042 106.832C163.574 109.986 158.951 115.812 152.208 113.883Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M160.445 104.049C161.53 101.452 164.736 95.997 168.873 94.958C169.313 97.9884 168.244 104.049 160.445 104.049Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.127 93.8448C162.935 90.6289 163.357 83.9002 166.575 82.7128C168.363 85.4339 170.176 91.47 163.127 93.8448Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M160.445 82.7128C160.445 82.7128 156.039 78.4455 158.529 71.5807C161.211 74.0173 165.349 79.6551 160.445 82.7128Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 85.29,
			cy: 98.0504,
			rx: 27.5844,
			ry: 26.717,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.671 85.8366C79.671 85.594 79.7592 85.3596 79.9192 85.1772L90.1789 73.4775C90.7873 72.7836 91.9308 73.214 91.9308 74.1368V116.998H79.671V85.8366Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.9308 105.224C85.8009 105.224 85.8009 111.161 79.671 111.656V117.099H91.9308V105.224Z",
			fill: "#B1B9D0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.234 81.689C106.234 81.4671 106.16 81.2514 106.024 81.0761L95.7642 67.8503C95.1802 67.0974 93.974 67.5104 93.974 68.4632V116.998H106.234V81.689Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 77.6277,
			y: 116.008,
			width: 30.6494,
			height: 1.97904,
			rx: .989518,
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87.8442,
			y: 79.3959,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87.8442,
			y: 85.333,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.147,
			y: 85.333,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87.8442,
			y: 97.2072,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.147,
			y: 97.2072,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87.8442,
			y: 109.081,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.147,
			y: 109.081,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87.8442,
			y: 91.2701,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.147,
			y: 91.2701,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 87.8442,
			y: 103.144,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 102.147,
			y: 103.144,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.7792,
			y: 85.333,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.0823,
			y: 85.333,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.0823,
			y: 79.3959,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.7792,
			y: 97.2072,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.0823,
			y: 97.2072,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.234 92.3606C102.147 99.4851 100.104 104.235 93.974 105.224V116.109H106.234V92.3606Z",
			fill: "#B1B9D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.7792,
			y: 109.081,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.0823,
			y: 109.081,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.7792,
			y: 91.2701,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.0823,
			y: 91.2701,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 84.7792,
			y: 103.144,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.0823,
			y: 103.144,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.7143,
			y: 85.333,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 85.333,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 79.3959,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 73.4587,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.7143,
			y: 97.2072,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 97.2072,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.7143,
			y: 109.081,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 109.081,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.7143,
			y: 91.2701,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 91.2701,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 81.7143,
			y: 103.144,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 96.0173,
			y: 103.144,
			width: 2.04329,
			height: 3.95807,
			rx: .5,
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 157.836,
			y1: 133.118,
			x2: 157.836,
			y2: 134.055,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 157.836,
			y1: 134.868,
			x2: 157.836,
			y2: 135.805,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 156.482,
			y1: 134.493,
			x2: 157.461,
			y2: 134.493,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 158.288,
			y1: 134.493,
			x2: 159.268,
			y2: 134.493,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 208.398,
			cy: 111.161,
			rx: 12.2597,
			ry: 11.8742,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.3442 63.886C89.3442 64.5015 88.8274 65.0105 88.1771 65.0105C87.5268 65.0105 87.01 64.5015 87.01 63.886C87.01 63.2706 87.5268 62.7615 88.1771 62.7615C88.8274 62.7615 89.3442 63.2706 89.3442 63.886Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M157.794 50.1338C157.794 50.7493 157.278 51.2583 156.627 51.2583C155.977 51.2583 155.46 50.7493 155.46 50.1338C155.46 49.5184 155.977 49.0093 156.627 49.0093C157.278 49.0093 157.794 49.5184 157.794 50.1338Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.9979 112.372C72.9979 112.988 72.481 113.497 71.8308 113.497C71.1805 113.497 70.6637 112.988 70.6637 112.372C70.6637 111.757 71.1805 111.248 71.8308 111.248C72.481 111.248 72.9979 111.757 72.9979 112.372Z",
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 186.73,
			y1: 86.9869,
			x2: 186.73,
			y2: 87.9239,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 186.73,
			y1: 88.7363,
			x2: 186.73,
			y2: 89.6733,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 185.375,
			y1: 88.3613,
			x2: 186.355,
			y2: 88.3613,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 187.181,
			y1: 88.3613,
			x2: 188.161,
			y2: 88.3613,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M146.298 114.042C146.09 113.927 146.401 113.633 146.797 113.571L147.874 113.402C148.198 113.351 148.341 113.499 148.146 113.683L147.634 114.166C147.439 114.351 147.033 114.45 146.863 114.356L146.298 114.042Z",
			fill: "black",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .1875,
			y1: -.1875,
			x2: 4.58518,
			y2: -.1875,
			transform: "matrix(-0.714401 0.699737 -0.722197 -0.691688 185.245 89.6394)",
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.58605,
			y2: -.5625,
			transform: "matrix(0.718311 0.695722 -0.718311 0.695722 89.8875 134.415)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.58605,
			y2: -.5625,
			transform: "matrix(0.718311 0.695722 -0.718311 0.695722 93.951 138.351)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.58605,
			y2: -.5625,
			transform: "matrix(0.718311 -0.695722 0.718311 0.695722 90.9711 141.237)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.58605,
			y2: -.5625,
			transform: "matrix(0.718311 -0.695722 0.718311 0.695722 95.0347 137.301)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .1875,
			y1: -.1875,
			x2: 7.7853,
			y2: -.1875,
			transform: "matrix(-0.715973 0.698128 -0.72064 -0.693309 184.862 91.1237)",
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.6229 56.1086C95.6229 56.1086 97.1455 55.8707 97.7939 55.2427C98.4422 54.6148 98.6879 53.14 98.6879 53.14C98.6879 53.14 98.9335 54.6148 99.5818 55.2427C100.23 55.8707 101.753 56.1086 101.753 56.1086C101.753 56.1086 100.23 56.3465 99.5818 56.9744C98.9335 57.6024 98.6879 59.0772 98.6879 59.0772C98.6879 59.0772 98.4422 57.6024 97.7939 56.9744C97.1455 56.3465 95.6229 56.1086 95.6229 56.1086Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.53 58.717C161.53 58.717 163.053 58.4791 163.701 57.8511C164.35 57.2232 164.595 55.7484 164.595 55.7484C164.595 55.7484 164.841 57.2232 165.489 57.8511C166.138 58.4791 167.66 58.717 167.66 58.717C167.66 58.717 166.138 58.9549 165.489 59.5828C164.841 60.2108 164.595 61.6856 164.595 61.6856C164.595 61.6856 164.35 60.2108 163.701 59.5828C163.053 58.9549 161.53 58.717 161.53 58.717Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.874 136.641C112.874 136.641 114.397 136.404 115.045 135.776C115.694 135.148 115.939 133.673 115.939 133.673C115.939 133.673 116.185 135.148 116.833 135.776C117.482 136.404 119.004 136.641 119.004 136.641C119.004 136.641 117.482 136.879 116.833 137.507C116.185 138.135 115.939 139.61 115.939 139.61C115.939 139.61 115.694 138.135 115.045 137.507C114.397 136.879 112.874 136.641 112.874 136.641Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_794_4719)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M101 61.9892C101 60.8846 101.895 59.9892 103 59.9892H142.529C143.051 59.9892 143.553 60.1934 143.927 60.5583L147.098 63.6553L150.399 66.8851C150.783 67.2614 151 67.7766 151 68.3146V119.702C151 120.807 150.105 121.702 149 121.702H103C101.895 121.702 101 120.807 101 119.702V61.9892Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.75,
			y1: 84.4216,
			x2: 133.858,
			y2: 84.4216,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.75,
			y1: 98.9499,
			x2: 133.858,
			y2: 98.9499,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.75,
			y1: 88.2958,
			x2: 133.858,
			y2: 88.2958,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.75,
			y1: 102.824,
			x2: 133.858,
			y2: 102.824,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.75,
			y1: 92.17,
			x2: 133.858,
			y2: 92.17,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.75,
			y1: 106.698,
			x2: 133.858,
			y2: 106.698,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 111.26,
			y1: 69.2846,
			x2: 123.183,
			y2: 69.2846,
			stroke: "#031A6B",
			strokeOpacity: .5,
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.76,
			y1: 74.499,
			x2: 141.923,
			y2: 74.499,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 110.76,
			y1: 77.7845,
			x2: 127.925,
			y2: 77.7845,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_794_4719)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M143.424 67.2619L150.933 67.6255L143.049 59.9893L143.424 67.2619Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.049 107.441C120.81 107.561 120.524 107.41 120.501 107.149L120.339 105.313C120.313 105.017 120.636 104.808 120.902 104.95L122.751 105.934C123.017 106.076 123.008 106.452 122.736 106.589L121.049 107.441Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.51023,
			height: 25.0172,
			rx: .75,
			transform: "matrix(0.882705 0.469927 -0.493563 0.86971 132.412 83.2349)",
			fill: "#FFB484"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.574 83.8531L134.849 84.5316C135.214 84.7263 135.345 85.1761 135.14 85.5363L123.533 105.989C123.329 106.35 122.867 106.484 122.501 106.289L122.388 106.229L133.574 83.8531Z",
			fill: "#F29559"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_794_4719",
			x: 98.5,
			y: 59.9892,
			width: 55,
			height: 69.2131,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 5 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.25 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.614167 0 0 0 0 0.614167 0 0 0 0 0.733333 0 0 0 0.15 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_794_4719"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_794_4719",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_794_4719",
			x: 141.549,
			y: 59.4893,
			width: 10.8842,
			height: 10.6362,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .75 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_794_4719"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_794_4719",
					result: "shape"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgPhaseOne);
export { ForwardRef as ReactComponent };
